module.exports = __webpack_public_path__ + "media/images/features/modification/thumb-voice-2-7316faae0164d925f46e486c0e137ecb.jpg";